import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Footer = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/newsletter`, { email });
      setMessage('Thank you for subscribing!');
      setEmail('');
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage('Error subscribing. Please try again.');
      setTimeout(() => setMessage(''), 3000);
    }
  };

  return (
    <footer className="bg-[#2C1810] text-[#F5F2EB] relative" data-testid="footer">
      <div className="hero-grain"></div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="mb-4 flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_5652a5b2-0bf3-4ac0-b2a9-e954b340d44d/artifacts/2zrootit_ChatGPT_Image_Apr_10__2026__11_26_27_PM-removebg-preview.png" 
                alt="Rasaa Designs Co Logo" 
                className="h-10 w-auto"
              />
              <div className="flex flex-col leading-tight">
                <span className="text-xl font-semibold text-[#F5F2EB] tracking-wide" style={{ fontFamily: 'Playfair Display, serif' }}>
                  RASAA ~
                </span>
                <span className="text-sm font-semibold text-[#F5F2EB] tracking-[0.2em]" style={{ fontFamily: 'Playfair Display, serif' }}>
                  THE ESSENCE
                </span>
              </div>
            </div>
            <p className="text-[#8D7B68] leading-relaxed">
              Crafting timeless products that honor traditional artisan techniques and sustainable practices.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-medium mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Quick Links
            </h4>
            <ul className="space-y-2 text-[#8D7B68]">
              <li><Link to="/woodwork-and-art" className="hover:text-[#B87333] transition-colors">Woodwork & Art</Link></li>
              <li><Link to="/mandirs" className="hover:text-[#B87333] transition-colors">Bespoke Mandirs</Link></li>
              <li><Link to="/copperware" className="hover:text-[#B87333] transition-colors">Artisan Metals</Link></li>
              <li><Link to="/candles" className="hover:text-[#B87333] transition-colors">Ayurvedic Aromas</Link></li>
              <li><Link to="/about" className="hover:text-[#B87333] transition-colors">About</Link></li>
              <li><Link to="/contact" className="hover:text-[#B87333] transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-medium mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Newsletter
            </h4>
            <p className="text-[#8D7B68] text-sm mb-4">
              Subscribe for new arrivals and artisan stories.
            </p>
            <form onSubmit={handleNewsletterSubmit} className="flex flex-col gap-2" data-testid="newsletter-form">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                className="bg-transparent border-b border-[#5D4037] px-0 py-2 focus:border-[#B87333] focus:outline-none placeholder:text-[#8D7B68]"
                required
                data-testid="newsletter-email-input"
              />
              <button type="submit" className="btn-primary w-full" data-testid="newsletter-submit-button">
                Subscribe
              </button>
              {message && <p className="text-sm text-[#B87333]" data-testid="newsletter-message">{message}</p>}
            </form>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#5D4037] text-center text-[#8D7B68] text-sm space-y-2">
          <p className="font-medium text-[#D4A843]">Proudly US-Based | Ships Nationwide</p>
          <p>&copy; {new Date().getFullYear()} Rasaa ~ The Essence. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
